import { render, staticRenderFns } from "./EmployeeResponsibilities.vue?vue&type=template&id=c0f6a0f4&scoped=true"
import script from "./EmployeeResponsibilities.vue?vue&type=script&lang=js"
export * from "./EmployeeResponsibilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f6a0f4",
  null
  
)

export default component.exports